import React from "react";
import ClientFooter from "./ClientFooter";

const RefundPolicy = () => {
    return (
        <>
            <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inner text-center">
                                <h2 className="title">Refund Policy</h2>
                                <ul className="page-list">
                                    <li className="rbt-breadcrumb-item">
                                        <a href="index.html">Home</a>
                                    </li>
                                    <li>
                                        <div className="icon-right">
                                            <i className="feather-chevron-right" />
                                        </div>
                                    </li>
                                    <li className="rbt-breadcrumb-item active">Refund Policy</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="rbt-overlay-page-wrapper">
                <div className="rbt-putchase-guide-area breadcrumb-style-max-width rbt-section-gapBottom">
                    <div className="rbt-article-content-wrapper">
                        <div className="content mt-5">
                            <h4>Refund Policy – Day Trading Tactics</h4>

                            <div className="mb-4">
                                <p><strong>Company Name:</strong> Day Trading Tactics</p>
                                <p><strong>Effective Date:</strong> 11/05/2025</p>
                                <p><strong>Address:</strong> Mogappair, Chennai, India</p>
                                <p><strong>Contact:</strong> venkateshan@daytradingtactics.in</p>
                            </div>

                            <h4>Important Notice</h4>
                            <p className="mb-4">
                                At <b>Day Trading Tactics</b>, we aim to provide high-quality trading education and resources. Please read this Refund Policy carefully before making any purchase on our website.
                            </p>

                            <h4>No Refund Policy</h4>
                            <p className="mb-3">
                                Once a course or any associated product is purchased, <b>no refunds will be issued under any circumstances</b>. This includes:
                            </p>
                            <ul className="mb-4">
                                <li>Course access</li>
                                <li>Video modules</li>
                                <li>Downloadable content (PDFs, worksheets)</li>
                                <li>Live mentoring sessions</li>
                                <li>Add-on services or support groups</li>
                            </ul>

                            <h4>Live Market Session & Add-On Pack</h4>
                            <p className="mb-4">
                                If you purchase access to a Live Market Session or an add-on pack for extended market session support, please note that <b>no refunds will be provided for these services</b>.<br />
                                These are considered premium support/mentorship services and are delivered via real-time participation.
                            </p>

                            <h4>Legal Notice</h4>
                            <p className="mb-4">
                                By completing a purchase on our website, you acknowledge and agree to this no-refund policy. This policy is legally binding and is governed by the laws of India, under the jurisdiction of courts in Chennai, Tamil Nadu.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <ClientFooter/>
        </>
    );
};

export default RefundPolicy; 